import type { InviteRegistrationView, ResidentApplicationData } from '@/types/application'

function text(value: unknown) {
  if (value == null) return ''
  return String(value).trim()
}

function propertyAddress(application: ResidentApplicationData) {
  const property = application.property
  if (!property) return ''
  const cityLine = [property.property_city, property.property_state, property.property_zipcode]
    .map(text)
    .filter(Boolean)
    .join(', ')
  return [property.property_address, property.property_address2, cityLine]
    .map(text)
    .filter(Boolean)
    .join(', ')
}

function agentName(application: ResidentApplicationData) {
  const agent = application.agent
  const fromUser = [agent?.first_name, agent?.last_name].map(text).filter(Boolean).join(' ')
  if (fromUser) return fromUser
  const other = application.other_agent
  return [other?.first_name, other?.last_name].map(text).filter(Boolean).join(' ')
}

/**
 * Invite tab view. Prefers the GET `invite_registration` object, then the same saved columns.
 */
export function inviteTabSnapshot(
  application: ResidentApplicationData | null | undefined,
): InviteRegistrationView {
  const saved = application?.invite_registration
  if (saved?.personal || saved?.property) {
    return saved
  }

  const user = application?.user_data
  return {
    personal: {
      first_name: text(user?.first_name || application?.first_name || application?.applicant_first_name),
      middle_name: text(user?.middle_name || application?.middle_name),
      last_name: text(user?.last_name || application?.last_name || application?.applicant_last_name),
      birthdate: text(application?.birthdate),
      security_number: text(application?.security_number),
      email: text(user?.email || application?.email || application?.applicant_email),
      mobile_no: text(user?.mobile_no || application?.mobile_no || application?.applicant_mobile_no),
      shared_phone_no: text(user?.shared_phone_no || application?.shared_phone_no),
      communication_preference: text(application?.communication_preference),
    },
    property: {
      property_name: text(application?.property?.property_name || application?.property_name),
      property_address: propertyAddress(application ?? {}),
      rent_amount: application?.rent_amount ?? null,
      access_fee: application?.access_fee ?? null,
      balance_due: application?.balance_due ?? null,
      unit_number: text(application?.unit_number),
      lease_start_date: text(application?.lease_start_date),
      lease_duration: text(application?.lease_duration),
      invite_code: text(application?.invite_code),
      agent_name: agentName(application ?? {}),
      agent_email: text(application?.agent?.email || application?.other_agent?.email),
      expected_residents: application?.expected_residents ?? null,
    },
  }
}
